import produce from 'immer';
import {
  GET_STORE_CUSTOMERS_GRID_START,
  GET_STORE_CUSTOMERS_GRID_SUCCESS,
  GET_STORE_CUSTOMERS_GRID_FAILED,
  GET_STORE_CUSTOMER_GROUPS_START,
  GET_STORE_CUSTOMER_GROUPS_SUCCESS,
  GET_STORE_CUSTOMER_GROUPS_FAILED,
  GET_STORE_CUSTOMER_DEFAULT_GROUP_START,
  GET_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS,
  GET_STORE_CUSTOMER_DEFAULT_GROUP_FAILED,
  EDIT_STORE_CUSTOMER_DEFAULT_GROUP_START,
  EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS,
  EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED,
  GET_STORE_CUSTOMER_DATA_START,
  GET_STORE_CUSTOMER_DATA_SUCCESS,
  GET_STORE_CUSTOMER_DATA_FAILED,
  DELETE_CUSTOMER_ACCOUNT_START,
  DELETE_CUSTOMER_ACCOUNT_SUCCESS,
  DELETE_CUSTOMER_ACCOUNT_FAILED,
  LOGIN_AS_CUSTOMER_START,
  LOGIN_AS_CUSTOMER_SUCCESS,
  LOGIN_AS_CUSTOMER_FAILED,
  RESET_CUSTOMER_PASSWORD_START,
  RESET_CUSTOMER_PASSWORD_SUCCESS,
  RESET_CUSTOMER_PASSWORD_FAILED,
  UPDATE_CUSTOMER_DATA_START,
  UPDATE_CUSTOMER_DATA_SUCCESS,
  UPDATE_CUSTOMER_DATA_FAILED,
  CREATE_CUSTOMER_START,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILED,
  GET_CUSTOMER_REWARDS_START,
  GET_CUSTOMER_REWARDS_SUCCESS,
  GET_CUSTOMER_REWARDS_FAILED,
  GET_CUSTOMER_REWARDS_BALANCE_START,
  GET_CUSTOMER_REWARDS_BALANCE_SUCCESS,
  GET_CUSTOMER_REWARDS_BALANCE_FAILED,
  UPDATE_CUSTOMER_REWARDS_BALANCE_START,
  UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS,
  UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED,
  GET_CUSTOMERS_ACCESS_LIST_START,
  GET_CUSTOMERS_ACCESS_LIST_SUCCESS,
  GET_CUSTOMERS_ACCESS_LIST_FAILED,
  UPDATE_CUSTOMERS_ACCESS_START,
  UPDATE_CUSTOMERS_ACCESS_SUCCESS,
  UPDATE_CUSTOMERS_ACCESS_FAILED,
  GET_STORE_CUSTOMER_CARD_DATA_START,
  GET_STORE_CUSTOMER_CARD_DATA_SUCCESS,
  GET_STORE_CUSTOMER_CARD_DATA_FAILED,
  GET_CUSTOMER_SUBSCRIPTIONS_START,
  GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTIONS_FAILED,
  GET_CUSTOMER_GIFTCARD_TRANSACTIONS_START,
  GET_CUSTOMER_GIFTCARD_TRANSACTIONS_SUCCESS,
  GET_CUSTOMER_GIFTCARD_TRANSACTIONS_FAILED,
  GET_CUSTOMER_GIFTCARDS_BALANCE_START,
  GET_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS,
  GET_CUSTOMER_GIFTCARDS_BALANCE_FAILED,
  UPDATE_CUSTOMER_GIFTCARDS_BALANCE_START,
  UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS,
  UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED,
  ADD_IMPORT_CUSTOMERS_TO_QUEUE_START,
  ADD_IMPORT_CUSTOMERS_TO_QUEUE_SUCCESS,
  ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED,
  RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE,
  GET_IMPORT_CUSTOMERS_QUEUE_TASKS_START,
  GET_IMPORT_CUSTOMERS_QUEUE_TASKS_SUCCESS,
  GET_IMPORT_CUSTOMERS_QUEUE_TASKS_FAILED,
  DELETE_IMPORT_CUSTOMER_QUEUE_TASK_START,
  DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS,
  DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED,
  GET_CUSTOMER_ACTIVE_CREDIT_CARDS_START,
  GET_CUSTOMER_ACTIVE_CREDIT_CARDS_SUCCESS,
  GET_CUSTOMER_ACTIVE_CREDIT_CARDS_FAILED,
  GET_EXISTING_CUSTOMERS_BY_EMAILS_START,
  GET_EXISTING_CUSTOMERS_BY_EMAILS_SUCCESS,
  GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED
} from '../actions/customers';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';

import {
  ADD_USER_STORE_SUCCESS
} from '../actions/admin';

import {
  EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS
} from '../actions/quote_marketing_segments';


const initialState = {
  storeCustomers: [],
  customersCSVData: [],
  customersData: {},
  customersTotalCount: 0,
  customerGroups: [],
  customerGroupsIds: [],
  customerDefaultGroup: {},
  customerCardData: [],
  customerActiveCardData: [],
  customerActivePaymentMethod: {},
  customersImportQueue: [],
  customerImportFileName: '',
  countOfCreatedQueueTasks: 0,
  queuedCustomersIds: [],
  rewardTransactions: [],
  rewardTransactionsTotalCount: 0,
  rewardsBalance: {},
  customerSubscriptions: {
    items: [],
    totalCount: 0
  },
  customerGiftCardTransactions: {
    items: [],
    totalCount: 0
  },
  giftCardsBalance: 0,
  requestAccessCustomersList: [],
  checkedCustomers: [],
  loadingCustomers: false,
  loadingCustomerGroups: false,
  loadingCustomerDefaultGroup: false,
  loadingCustomerData: false,
  deletingCustomerAccount: false,
  loginAsCustomer: false,
  resetCustomerPassword: false,
  updatingCustomerData: false,
  savingCustomerAccount: false,
  loadingRewardTransactions: false,
  loadingRewardsBalance: false,
  loadingRequestAccessList: false,
  loadingCustomerCardData: false,
  loadingCustomerActiveCardData: false,
  loadingCustomerSubscriptions: false,
  loadingCustomerGiftCardTransactions: false,
  loadingGiftCardsBalance: false,
  updatingGiftCardsBalance: false,
  loadingCustomersQueue: false,
  loadingExistingCustomersByEmails: false
};

const formReducer = produce((state: ICustomersState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_CUSTOMERS_GRID_START: {
      if (!action.isCSVData) {
        state.loadingCustomers = true;
      }

      break;
    }

    case GET_STORE_CUSTOMERS_GRID_SUCCESS: {
      const {data: {items, total_count}, isCSVData} = action;

      if (isCSVData) {
        const customers = items.map((customer) => {
          const {
            name,
            email,
            billing_full,
            billing_telephone,
            phone_number,
            group_id
          } = customer;
          const customerGroup = state.customerGroups.find((group) => group.id == group_id);

          return {
            'Name': name,
            'Email': email,
            'Billing Address': billing_full,
            'Phone': billing_telephone || phone_number || '',
            'Customer Group': customerGroup?.code || ''
          };
        });
        state.customersCSVData = customers;
      } else {
        state.storeCustomers = items;
        state.loadingCustomers = false;
      }

      state.customersTotalCount = total_count;
      break;
    }

    case GET_STORE_CUSTOMERS_GRID_FAILED: {
      if (!action.isCSVData) {
        state.loadingCustomers = false;
      }

      break;
    }

    case GET_STORE_CUSTOMER_GROUPS_START: {
      state.loadingCustomerGroups = true;
      break;
    }
    case GET_STORE_CUSTOMER_GROUPS_SUCCESS: {
      const { data } = action;

      state.customerGroups = data;
      state.customerGroupsIds = data.map((group) => group.id);
      state.loadingCustomerGroups = false;
      break;
    }
    case GET_STORE_CUSTOMER_GROUPS_FAILED: {
      state.loadingCustomerGroups = false;
      break;
    }

    case GET_STORE_CUSTOMER_DEFAULT_GROUP_START: {
      state.loadingCustomerGroups = true;
      break;
    }

    case GET_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS: {
      const { data } = action;

      state.customerDefaultGroup = data;
      state.loadingCustomerDefaultGroup = false;
      break;
    }

    case GET_STORE_CUSTOMER_DEFAULT_GROUP_FAILED: {
      state.loadingCustomerGroups = false;
      break;
    }

    case EDIT_STORE_CUSTOMER_DEFAULT_GROUP_START: {
      state.loadingCustomerGroups = true;
      break;
    }
    case EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS: {
      const { data } = action;

      state.customerDefaultGroup = data;
      state.loadingCustomerDefaultGroup = false;
      break;
    }
    case EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED: {
      state.loadingCustomerGroups = false;
      break;
    }

    case GET_STORE_CUSTOMER_CARD_DATA_START: {
      state.loadingCustomerCardData = true;
      break;
    }
    case GET_STORE_CUSTOMER_CARD_DATA_SUCCESS: {
      const { data } = action;

      state.customerCardData = data;
      state.loadingCustomerCardData = false;
      break;
    }
    case GET_CUSTOMER_ACTIVE_CREDIT_CARDS_START: {
      state.loadingCustomerActiveCardData = true;
      break;
    }
    case GET_CUSTOMER_ACTIVE_CREDIT_CARDS_SUCCESS: {
      const { data } = action;

      state.customerActiveCardData = data.activePaymentCards;
      state.customerActivePaymentMethod = data.activePaymentMethod;
      state.loadingCustomerActiveCardData = false;
      break;
    }
    case GET_CUSTOMER_ACTIVE_CREDIT_CARDS_FAILED: {
      state.loadingCustomerActiveCardData = false;
      break;
    }
    case GET_EXISTING_CUSTOMERS_BY_EMAILS_START: {
      state.loadingExistingCustomersByEmails = true;
      break;
    }
    case GET_EXISTING_CUSTOMERS_BY_EMAILS_SUCCESS: {
      state.loadingExistingCustomersByEmails = false;
      break;
    }
    case GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED: {
      state.loadingExistingCustomersByEmails = false;
      break;
    }
    case GET_STORE_CUSTOMER_CARD_DATA_FAILED: {
      state.loadingCustomerCardData = false;
      break;
    }

    case GET_CUSTOMERS_ACCESS_LIST_START: {
      state.loadingRequestAccessList = true;
      break;
    }

    case GET_CUSTOMERS_ACCESS_LIST_SUCCESS: {
      const {data} = action;

      state.requestAccessCustomersList = data.list.items;
      state.customersTotalCount = data.list.total_count;
      state.loadingRequestAccessList = false;
      break;
    }

    case GET_CUSTOMERS_ACCESS_LIST_FAILED: {
      state.loadingRequestAccessList = false;
      break;
    }

    case UPDATE_CUSTOMERS_ACCESS_START: {
      state.loadingRequestAccessList = true;
      break;
    }
    case UPDATE_CUSTOMERS_ACCESS_SUCCESS: {
      const { updatedParamsAccess } = action;
      state.requestAccessCustomersList = state.requestAccessCustomersList.map((customer) => {
        const updatedCustomer = updatedParamsAccess.find((param) => customer.id === param.id);

        return {...customer, request_access: updatedCustomer ? updatedCustomer.request_access : customer.request_access};
      });

      state.loadingRequestAccessList = false;
      break;
    }
    case UPDATE_CUSTOMERS_ACCESS_FAILED: {
      state.loadingRequestAccessList = false;
      break;
    }

    case GET_STORE_CUSTOMER_DATA_START: {
      state.loadingCustomerData = true;
      break;
    }
    case GET_STORE_CUSTOMER_DATA_SUCCESS: {
      const { data: {customer} } = action;

      state.customersData[customer.id] = customer;
      state.loadingCustomerData = false;
      break;
    }
    case GET_STORE_CUSTOMER_DATA_FAILED: {
      state.loadingCustomerData = false;
      break;
    }

    case DELETE_CUSTOMER_ACCOUNT_START: {
      state.deletingCustomerAccount = true;
      break;
    }
    case DELETE_CUSTOMER_ACCOUNT_SUCCESS: {
      const {id} = action;
      state.storeCustomers = state.storeCustomers
        .filter((customer) => customer.entity_id != id);
      state.customersCSVData = state.customersCSVData
        .filter((customer) => customer.entity_id != id);
      state.deletingCustomerAccount = false;
      break;
    }
    case DELETE_CUSTOMER_ACCOUNT_FAILED: {
      state.deletingCustomerAccount = false;
      break;
    }

    case LOGIN_AS_CUSTOMER_START: {
      state.loginAsCustomer = true;
      break;
    }
    case LOGIN_AS_CUSTOMER_SUCCESS: {
      const {url} = action;
      window.open(url, '_blank');
      state.loginAsCustomer = false;
      break;
    }
    case LOGIN_AS_CUSTOMER_FAILED: {
      state.loginAsCustomer = false;
      break;
    }

    case RESET_CUSTOMER_PASSWORD_START: {
      state.resetCustomerPassword = true;
      break;
    }
    case RESET_CUSTOMER_PASSWORD_SUCCESS: {
      state.resetCustomerPassword = false;
      break;
    }
    case RESET_CUSTOMER_PASSWORD_FAILED: {
      state.resetCustomerPassword = false;
      break;
    }

    case UPDATE_CUSTOMER_DATA_START: {
      state.updatingCustomerData = true;
      break;
    }
    case UPDATE_CUSTOMER_DATA_SUCCESS: {
      const {data: {customer}} = action;
      state.customersData[customer.id] = customer;
      state.customersCSVData = [];
      state.updatingCustomerData = false;
      break;
    }
    case UPDATE_CUSTOMER_DATA_FAILED: {
      state.updatingCustomerData = false;
      break;
    }

    case CREATE_CUSTOMER_START: {
      state.savingCustomerAccount = true;
      break;
    }
    case CREATE_CUSTOMER_SUCCESS: {
      const {data: {customer: {
        created_at,
        created_in,
        dob,
        email,
        id,
        gender,
        group_id,
        firstname,
        lastname,
        website_id
      }}} = action;

      const customerDataGrid = {
        billing_full: '',
        shipping_full: '',
        created_at,
        created_in,
        dob,
        email,
        entity_id: id,
        gender,
        group_id,
        name: `${firstname} ${lastname}`,
        website_id
      };

      state.storeCustomers = [customerDataGrid, ...state.storeCustomers];
      state.customersCSVData = [];
      state.savingCustomerAccount = false;
      break;
    }
    case CREATE_CUSTOMER_FAILED: {
      state.savingCustomerAccount = false;
      break;
    }
    case GET_CUSTOMER_REWARDS_START: {
      state.loadingRewardTransactions = true;
      break;
    }
    case GET_CUSTOMER_REWARDS_SUCCESS: {
      const {data: {rewardTransactions: {items, total_count}}} = action;
      state.rewardTransactions = items;
      state.rewardTransactionsTotalCount = total_count;
      state.loadingRewardTransactions = false;
      break;
    }
    case GET_CUSTOMER_REWARDS_FAILED: {
      state.loadingRewardTransactions = false;
      break;
    }

    case GET_CUSTOMER_REWARDS_BALANCE_START: {
      state.loadingRewardsBalance = true;
      break;
    }
    case GET_CUSTOMER_REWARDS_BALANCE_SUCCESS: {
      const {data: {balance: {items}}} = action;

      state.rewardsBalance = items?.[0] || {};
      state.loadingRewardsBalance = false;
      break;
    }
    case GET_CUSTOMER_REWARDS_BALANCE_FAILED: {
      state.loadingRewardsBalance = false;
      break;
    }
    case UPDATE_CUSTOMER_REWARDS_BALANCE_START: {
      state.loadingRewardsBalance = true;
      break;
    }
    case UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS: {
      const {balance: {point_amount}} = action;

      if (!state.rewardsBalance.point_balance) {
        state.rewardsBalance = {
          point_balance: point_amount,
          extension_attributes: {
            total_earning_points: point_amount
          }
        };
      } else {
        state.rewardsBalance = {
          ...state.rewardsBalance,
          point_balance: state.rewardsBalance.point_balance + point_amount,
          extension_attributes: {
            ...state.rewardsBalance.extension_attributes,
            total_earning_points: state.rewardsBalance.extension_attributes.total_earning_points + point_amount
          }
        };
      }

      state.loadingRewardsBalance = false;
      break;
    }
    case UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED: {
      state.loadingRewardsBalance = false;
      break;
    }

    case GET_CUSTOMER_SUBSCRIPTIONS_START: {
      state.loadingCustomerSubscriptions = true;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS: {
      const {items, total_count: totalCount} = action.data;

      state.customerSubscriptions = {
        items,
        totalCount
      };
      state.loadingCustomerSubscriptions = false;
      break;
    }
    case GET_CUSTOMER_SUBSCRIPTIONS_FAILED: {
      state.loadingCustomerSubscriptions = false;
      break;
    }

    case GET_CUSTOMER_GIFTCARD_TRANSACTIONS_START: {
      state.loadingCustomerGiftCardTransactions = true;
      break;
    }
    case GET_CUSTOMER_GIFTCARD_TRANSACTIONS_SUCCESS: {
      const {items, total_count: totalCount} = action.data.transactions;

      state.customerGiftCardTransactions = {
        items,
        totalCount
      };
      state.loadingCustomerGiftCardTransactions = false;
      break;
    }
    case GET_CUSTOMER_GIFTCARD_TRANSACTIONS_FAILED: {
      state.loadingCustomerGiftCardTransactions = false;
      break;
    }

    case GET_CUSTOMER_GIFTCARDS_BALANCE_START: {
      state.loadingGiftCardsBalance = true;
      break;
    }
    case GET_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS: {
      const {balance} = action.data;

      state.giftCardsBalance = balance;
      state.loadingGiftCardsBalance = false;
      break;
    }
    case GET_CUSTOMER_GIFTCARDS_BALANCE_FAILED: {
      state.loadingGiftCardsBalance = false;
      break;
    }

    case UPDATE_CUSTOMER_GIFTCARDS_BALANCE_START: {
      state.updatingGiftCardsBalance = true;
      break;
    }
    case UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS: {
      const {balance} = action;
      state.giftCardsBalance += balance;
      state.updatingGiftCardsBalance = false;
      break;
    }

    case UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED: {
      state.updatingGiftCardsBalance = false;
      break;
    }

    case ADD_IMPORT_CUSTOMERS_TO_QUEUE_START: {
      state.loadingCustomersQueue = true;
      break;
    }

    case ADD_IMPORT_CUSTOMERS_TO_QUEUE_SUCCESS: {
      const {tasks, fileName} = action;
      state.customersImportQueue = tasks;
      state.countOfCreatedQueueTasks = tasks.length;
      state.customerImportFileName = fileName;
      state.loadingCustomersQueue = false;
      break;
    }

    case ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED: {
      state.loadingCustomersQueue = false;
      break;
    }

    case GET_IMPORT_CUSTOMERS_QUEUE_TASKS_START: {
      state.loadingCustomersQueue = true;
      break;
    }

    case GET_IMPORT_CUSTOMERS_QUEUE_TASKS_SUCCESS: {
      state.customersImportQueue = action.data;
      state.countOfCreatedQueueTasks = action.data.length;
      state.loadingCustomersQueue = false;
      break;
    }

    case GET_IMPORT_CUSTOMERS_QUEUE_TASKS_FAILED: {
      state.loadingCustomersQueue = false;
      break;
    }

    case RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE: {
      const {action: taskAction, task} = action.data;

      if (taskAction === 'CUSTOMER_IMPORT_TASK_COMPLETED') {
        state.customersImportQueue = state.customersImportQueue.filter((t) => t._id !== task._id);
      }

      if (taskAction === 'CUSTOMER_IMPORT_TASK_UPDATED' && task.status === 'FAILED') {
        state.customersImportQueue = state.customersImportQueue.map((t) => t._id == task._id ? task : t);
      }

      break;
    }

    case DELETE_IMPORT_CUSTOMER_QUEUE_TASK_START: {
      state.loadingCustomersQueue = true;
      break;
    }

    case DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS: {
      state.customersImportQueue = state.customersImportQueue.filter((task) => task._id !== action.id);
      state.loadingCustomersQueue = false;
      break;
    }

    case DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED: {
      state.loadingCustomersQueue = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.customerGroupsIds = [];
      state.customersCSVData = initialState.customersCSVData;
      state.customerGroups = initialState.customerGroups;
      state.requestAccessCustomersList = initialState.requestAccessCustomersList;
      state.customersTotalCount = initialState.customersTotalCount;
      state.customerDefaultGroup = initialState.customerDefaultGroup;
      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      state.customerGroupsIds = [];
      state.customerGroups = initialState.customerGroups;
      state.customerDefaultGroup = initialState.customerDefaultGroup;
      break;
    }

    case EDIT_MARKETING_SEGMENTS_CUSTOMER_SUCCESS: {
      const {data: {customer}} = action;
      state.customersData[customer.id] = customer;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
